<template>
  <sidebar
  :addTitle="$t('Decarbonization.GridEfficiency.AddNew')"
  :editTitle="$t('Decarbonization.GridEfficiency.Edit')"
  :isSidebarActive="isSidebarActive"
  :data="data"
  @onNewData="newData"
  @onEditData="editData"
  @closeSidebar="closeSidebar">
    <ValidationObserver ref="observer">
      <div class="p-6">
        <vs-row class="mb-3">
          <vs-col vs-w="6">
            <ValidationProvider :name="$t('Decarbonization.GridEfficiency.StartYear')" rules="required|numeric|between:2022,2100" v-slot="{ errors }">
              <validated-input
              :label="$t('Decarbonization.GridEfficiency.StartYear')"
              v-model="startYear"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="6" class="mr-5">
            <ValidationProvider :name="$t('Decarbonization.GridEfficiency.EndYear')" rules="numeric|between:2022,2100" v-slot="{ errors }">
              <validated-input
              :label="$t('Decarbonization.GridEfficiency.EndYear')"
              v-model="endYear"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="6" class="mr-5">
            <ValidationProvider :name="$t('Decarbonization.GridEfficiency.Rate')" rules="required|decimal|between:0,1" v-slot="{ errors }">
              <validated-input
              :label="$t('Decarbonization.GridEfficiency.Rate')"
              v-model="rate"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
      </div>
    </ValidationObserver>
    
    <template v-slot:footer>
      <vs-button class="mr-6" @click="submitData">{{ $t('Submit') }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('Cancel') }}</vs-button>
    </template>
  </sidebar>
</template>

<script>

import {
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "@/app/shared/components";

export default {
  props: {    
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    },
    gridEfficiencyTemplateId : {
      type: Number
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    Sidebar
  },
  data() {
    return {
      id: 0,
      startYear: null,
      endYear: null,
      rate: 0.0
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.closeSidebar();
        }
      }
    }
  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      const { id, startYear, endYear, rate } = JSON.parse(JSON.stringify(this.data));
      this.id = id;
      this.startYear = startYear;
      this.endYear = endYear;
      this.rate = rate;
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;      
      this.name = "";
      this.id = 0;
      this.startYear = null;
      this.endYear = null;
      this.rate = 0.0;
    },    
    
    async submitData() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          const obj = {
            id: this.id,
            startYear: this.startYear,
            endYear: this.endYear,
            rate: this.rate,
            gridEfficiencyTemplateId: this.gridEfficiencyTemplateId
          };
         
          if (this.id !== null && this.id > 0) {
            this.$emit("onUpdated", obj);
          } else {
            this.$emit("onInserted", obj);
          }
        }
      });
    }
  }
};
</script>
